import React from 'react';
import classes from '../ContentPromotionPopup.module.css';

const getButtonStyle = (button) => ({
    "--promotion-text-color": button.textColor,
    "--promotion-background-color": button.backgroundColor,
    "--promotion-border-color": button.borderColor,
});

const CloseButtonPromotion = ({ button, text, onClose }) => (
    <button
        type="button"
        className={classes.Button}
        style={getButtonStyle(button)}
        onClick={onClose}
    >
        {text}
    </button>
);

export default CloseButtonPromotion;
